// Module
var code = "<offer-message listing-id=\"$ctrl.listingId\"></offer-message>";
// Exports
module.exports = code;